var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 316.908,
    height: 112.064,
    viewBox: "0 0 316.908 112.064",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1592",
    "data-name": "Group 1592",
    transform: "translate(118.983 44.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M314.48,148.725a45.972,45.972,0,0,1,6.914-.467c4.3,0,7.085.771,9.265,2.417,2.346,1.742,3.826,4.53,3.826,8.523,0,4.33-1.58,7.319-3.751,9.169-2.384,1.98-6.01,2.917-10.419,2.917a44.421,44.421,0,0,1-5.806-.338Zm5.135,18.463a9.493,9.493,0,0,0,1.78.1c4.63.033,7.652-2.5,7.652-7.919.033-4.7-2.717-7.181-7.114-7.181a10.727,10.727,0,0,0-2.317.2Z",
    transform: "translate(-314.48 -148.253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M374.224,165.473l-1.625,5.81H367.31l6.914-22.622h6.71l7.014,22.622h-5.5l-1.746-5.81Zm5.739-3.826-1.409-4.8c-.417-1.342-.809-3.022-1.142-4.364h-.067c-.338,1.342-.671,3.055-1.042,4.364l-1.342,4.8Z",
    transform: "translate(-345.292 -148.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M421.376,152.969H415.3V148.66h17.379v4.309h-6.168v18.338h-5.135Z",
    transform: "translate(-373.281 -148.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M462.724,165.467l-1.609,5.806H455.81l6.914-22.622h6.714l7.014,22.622h-5.5l-1.725-5.806Zm5.743-3.826-1.413-4.8c-.417-1.342-.8-3.022-1.142-4.364h-.067c-.333,1.342-.671,3.055-1.038,4.364l-1.346,4.8Z",
    transform: "translate(-396.908 -148.483)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M514.6,148.72a42.171,42.171,0,0,1,6.914-.467c3.155,0,5.418.6,6.914,1.813a6.593,6.593,0,0,1,2.417,5.235,7.219,7.219,0,0,1-2.084,5.372c-1.746,1.642-4.33,2.38-7.352,2.38a13,13,0,0,1-1.746-.1v8.09H514.6Zm5.068,10.261a7.893,7.893,0,0,0,1.713.133c2.717,0,4.4-1.375,4.4-3.693,0-2.084-1.442-3.334-3.993-3.334a8.8,8.8,0,0,0-2.117.2Z",
    transform: "translate(-431.195 -148.249)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M563.4,148.66h5.139V167h8.994v4.3H563.4Z",
    transform: "translate(-459.657 -148.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M610.014,165.467l-1.609,5.806H603.1l6.914-22.622h6.714l7.014,22.622h-5.5l-1.746-5.806Zm5.743-3.826-1.413-4.8c-.417-1.342-.8-3.022-1.138-4.364h-.071c-.333,1.342-.671,3.055-1.038,4.364l-1.342,4.8Z",
    transform: "translate(-482.811 -148.483)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M656.8,171.282v-9.265L649.65,148.66h5.835L657.8,154.1c.7,1.642,1.175,2.851,1.746,4.33h.067c.5-1.413,1.042-2.722,1.713-4.33l2.284-5.439h5.739l-7.452,13.191v9.432Z",
    transform: "translate(-509.96 -148.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M716.827,161.722h-8.335v5.372H717.8v4.193H703.37V148.66h13.962v4.2H708.5v4.7h8.335Z",
    transform: "translate(-541.291 -148.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M748.39,148.725a45.2,45.2,0,0,1,6.814-.467c3.334,0,5.706.5,7.314,1.775a5.754,5.754,0,0,1,2.084,4.735,6.006,6.006,0,0,1-4,5.572v.1c1.579.638,2.45,2.151,3.021,4.23.7,2.551,1.409,5.506,1.846,6.377h-5.235a28.56,28.56,0,0,1-1.58-5.268c-.6-2.822-1.575-3.593-3.659-3.626h-1.542v8.894H748.39Zm5.068,9.736h2.013c2.551,0,4.064-1.275,4.064-3.255,0-2.084-1.413-3.122-3.751-3.155a12.79,12.79,0,0,0-2.313.167Z",
    transform: "translate(-567.548 -148.254)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1593",
    "data-name": "Group 1593"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M222.018,80.458l.067-.058c-.417.025-.834.071-1.221.129-.308.042-.617.1-.921.158a17,17,0,0,0-2.751.788,17.175,17.175,0,0,0-6.252,4.1c-.046.354-.083.713-.117,1.071a34.049,34.049,0,0,0,.483,9.694c1.159,5.964,3.651,11.957,11.824,17.163h.067l.417-.129a24.089,24.089,0,0,1-1.625-32.829A.16.16,0,0,1,222.018,80.458Z",
    transform: "translate(-122.869 -46.891)",
    fill: "rgba(255,255,255,0.97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M186.846,47.55c-.071.538-.133,1.079-.183,1.621a44.378,44.378,0,0,0,4.768,24.59c.121.238.25.467.375.7q.492.917,1.021,1.8a44.274,44.274,0,0,0,13.337,14.062c.121.083.233.167.354.246l.138.083.046-.046.146-.142c.083-.071.167-.133.254-.2a5.164,5.164,0,0,1,1.225-.525c-8.519-5.268-11.086-11.365-12.266-17.434a34.446,34.446,0,0,1-.6-7.919c0-.442.042-.884.079-1.321A34.175,34.175,0,0,1,207.964,39.4c-.2-.021-.417-.033-.592-.046-.4-.029-.788-.054-1.184-.063a25.369,25.369,0,0,0-5.46.458A25.1,25.1,0,0,0,186.846,47.55Z",
    transform: "translate(-108.749 -22.91)",
    fill: "rgba(255,255,255,0.97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M162.118,57.193q1.121,1.667,2.38,3.238l.492.613a52.334,52.334,0,0,0,16.538,13.437l.529.271q2.13,1.067,4.334,1.938a5.038,5.038,0,0,1,.238-.475l-.079-.05c-.213-.133-.417-.267-.638-.417-.358-.233-.713-.479-1.063-.721h-.025A44.333,44.333,0,0,1,174.167,64.5c-.513-.717-1-1.459-1.484-2.213-.684-1.092-1.334-2.217-1.938-3.384a44.378,44.378,0,0,1-4.868-23.035c.042-.629.088-1.25.15-1.884a44.8,44.8,0,0,1,7.614-20.747q-1.138.217-2.267.517a33.075,33.075,0,0,0-18.267,12.5,52.263,52.263,0,0,0,9.011,30.933Z",
    transform: "translate(-89.28 -7.722)",
    fill: "rgba(255,255,255,0.97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M133.139,59.117a60,60,0,0,0,26.953,12.128l.7.113.05-.25c.021-.079.038-.158.058-.238A52.21,52.21,0,0,1,139.87,56.421q-.679-.763-1.33-1.563A52.647,52.647,0,0,1,130.676,1.44q-1.25.525-2.5,1.146A39.026,39.026,0,0,0,110,21.9,62.1,62.1,0,0,0,123.774,50.24a62.712,62.712,0,0,0,9.365,8.877Z",
    transform: "translate(-64.153 -0.84)",
    fill: "rgba(255,255,255,0.97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M88.694,62.357a69.563,69.563,0,0,0,8.131,4.5,67.755,67.755,0,0,0,33.946,6.252c.65-.05,1.3-.113,1.951-.179,0-.188-.021-.375-.033-.563v-.7q-2.284-.338-4.551-.834a61.953,61.953,0,0,1-24.3-11.386,62.75,62.75,0,0,1-5.543-4.793A62.02,62.02,0,0,1,81,23.694,62.616,62.616,0,0,1,80.275,0C79.4.633,78.55,1.3,77.721,2A46.141,46.141,0,0,0,62,29.195,67.646,67.646,0,0,0,88.694,62.357Z",
    transform: "translate(-36.158 0)",
    fill: "rgba(255,255,255,0.97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M61.621,93.262a72.288,72.288,0,0,0,15.1,1.584,71.269,71.269,0,0,0,27.465-5.468q-2.722.2-5.46.179a67.759,67.759,0,0,1-28.341-6.439l-.533-.258A67.8,67.8,0,0,1,36.231,47.134a68.488,68.488,0,0,1-4.914-21.826V25.22c-.784.884-1.538,1.792-2.259,2.734a50.429,50.429,0,0,0-9.932,37.818,71.172,71.172,0,0,0,42.494,27.49Z",
    transform: "translate(-10.859 -14.709)",
    fill: "rgba(255,255,255,0.97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M99.659,144.43c-1.063,0-1.759-.7-2.084-2.063-.329-1.45-.542-2.951-.7-4.226a3.072,3.072,0,0,0-.046-.388l-.05-.446-.063-.592-.038-.375a71.222,71.222,0,0,1-31.491,7.294q-3.388,0-6.693-.308A71.481,71.481,0,0,1,11.8,119.707q-1.538-1.738-2.959-3.576a.288.288,0,0,1,0,.054A71.373,71.373,0,0,1,2.13,105.92c-.354,1.188-.625,2.434-.892,3.651a52.888,52.888,0,0,0,99.1,34.725,2.047,2.047,0,0,1-.675.117Z",
    transform: "translate(0.006 -61.775)",
    fill: "rgba(255,255,255,0.97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M181.674,172.139a17.379,17.379,0,1,1,17.375-17.378,17.38,17.38,0,0,1-17.375,17.378Z",
    transform: "translate(-95.816 -80.124)",
    fill: "#98235c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2534",
    "data-name": "Path 2534",
    d: "M15.9,0A15.9,15.9,0,1,1,0,15.9,15.9,15.9,0,0,1,15.9,0Z",
    transform: "translate(69.962 58.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M207.87,163.929l-11.307-8.623a1.409,1.409,0,0,0-2.263,1.117v17.25a1.409,1.409,0,0,0,2.263,1.117l11.307-8.623a1.409,1.409,0,0,0,0-2.238Z",
    transform: "translate(-113.319 -90.41)",
    fill: "#98235c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6533f4d2.svg";
export { ForwardRef as ReactComponent };